import { lazyPage } from "./lazyPage";

// Модулите, чийто код се тегли чак при отваряне (docs/architecture.md §Код
// при отваряне). Вход, „Модули", ПИН екранът и „Маркиране" остават в началния
// пакет — с тях започва работата. Всяка страница е ЕДНА константа тук:
// `Inventory` обслужва всичките си маршрути (списъци и работни листове) със
// същия компонент, за да остане монтиран при преход между тях.

// ─── Цял екран ───
export const LunchMenuPage = lazyPage(() => import("../pages/ordering/lunch/LunchMenuPage"));
export const Monitors = lazyPage(() => import("../pages/monitors/Monitors"));
export const Reports = lazyPage(() => import("../pages/reports/Reports"));
export const Inventory = lazyPage(() => import("../pages/inventory/Inventory"));
export const Discounts = lazyPage(() => import("../pages/discounts/Discounts"));
export const Delivery = lazyPage(() => import("../pages/delivery/Delivery"));
export const AuditLog = lazyPage(() => import("../pages/monitoring/auditLog/AuditLog"));
export const Monitoring = lazyPage(() => import("../pages/monitoring/Monitoring"));
export const MonitoringFiscalIssues = lazyPage(
  () => import("../pages/monitoring/fiscalIssues/FiscalIssuesPage"),
);
export const MonitoringAssistant = lazyPage(
  () => import("../pages/monitoring/assistant/AssistantPage"),
);
export const MonitoringChangelog = lazyPage(
  () => import("../pages/monitoring/changelog/Changelog"),
);

// ─── Съдържанието до страничното меню на „Конфигурация" ───
export const MonitorsPage = lazyPage(
  () => import("../pages/configuration/components/monitors/MonitorsPage"),
  "content",
);
export const DevicesPage = lazyPage(
  () => import("../pages/configuration/components/devices/DevicesPage"),
  "content",
);
export const OrderingSettingsPage = lazyPage(
  () => import("../pages/configuration/components/ordering-settings/OrderingSettingsPage"),
  "content",
);
export const WorkingHoursPage = lazyPage(
  () => import("../pages/configuration/components/working-hours/WorkingHoursPage"),
  "content",
);
export const PaymentMethodsPage = lazyPage(
  () => import("../pages/configuration/components/payment-methods/PaymentMethodsPage"),
  "content",
);
export const CompaniesPage = lazyPage(
  () => import("../pages/configuration/components/companies/CompaniesPage"),
  "content",
);

// ─── Съдържанието до страничното меню на „Резервации" ───
export const Reservations = lazyPage(() => import("../pages/reservations/Reservations"), "content");
export const ReservationsTable = lazyPage(
  () => import("../pages/reservations/table/ReservationsTable"),
  "content",
);
export const RestaurantSchemaPage = lazyPage(
  () => import("../pages/reservations/restaurant-schema/RestaurantSchemaPage"),
  "content",
);
export const TablesConfigPage = lazyPage(
  () => import("../pages/reservations/tables-config/TablesConfigPage"),
  "content",
);
